import * as React from 'react';
import { twMerge } from 'tailwind-merge';

interface IdStampProps extends React.HTMLAttributes<HTMLSpanElement> {
  color?: string;
}

export const IdStamp = React.forwardRef<HTMLSpanElement, IdStampProps>(
  ({ color, children, className, style, ...rest }, ref) => {
    return (
      <span
        ref={ref}
        className={twMerge('font-mono text-[11px] tracking-[.04em]', !color && 'text-text-3', className)}
        style={color ? { color, ...style } : style}
        {...rest}
      >
        {children}
      </span>
    );
  },
);
IdStamp.displayName = 'IdStamp';
